import { comparator } from '@pes-ui/utils';
import './qds-types';
export function initStickyBarStore() {
  window.__STICKYBARSTORE = {
    items: [],
    active: {},
    setItem({ name, titles }) {
      const event = new Event('tabInit');
      this.items.push({ name, titles });
      window.dispatchEvent(event);
    },
  };
}
const pesAppTest = JSON.parse(localStorage.getItem('pesAppTest'));
if (pesAppTest) {
  const { dir = 'not_set' } = pesAppTest;
  document.dir = dir !== 'not_set' ? dir : document.dir;
}
initStickyBarStore();
comparator.setListeners();
